<template>
  <base-list-overview
    controller="FunctionalityGroup"
    :visible="visible"
  />
</template>

<script>
import BaseListOverview from '@/components/shared/base/base-list-overview'
import ContentMixin from '@/mixins/content-mixin'

export default {
  name: 'UserManagementProfilesOverview',
  components: {
    BaseListOverview
  },
  mixins: [
    ContentMixin
  ]
}
</script>
